import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { parseQs, stringifyQs } from 'helpers/http';

import ListFilterBody from 'components/layout/list/ListFilterBody';

class ListFilterLeadPriority extends React.Component {
  updatePriority = (e, priority) => {
    e.preventDefault();

    const { location, history } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...parseQs(location.search), priority }),
    });
  };

  reset = e => {
    this.updatePriority(e, undefined);
  };

  render() {
    const {
      intl: { messages },
      location,
    } = this.props;

    const query = parseQs(location.search);
    const isActive = query.priority !== undefined;

    return (
      <ListFilterBody
        title={messages.priority}
        isActive={isActive}
        paramNames={['priority']}
        body={
          <div className="list-view clearfix">
            <ul className="no-border">
              <li>
                <a className="p-t-5 p-b-5 relative block" href="#all" onClick={this.reset}>
                  <span className="top-left m-t-5">
                    {query.priority === undefined ? (
                      <i className="fa-fw fas fa-check-square text-primary" />
                    ) : (
                      <i className="fa-fw fas fa-square text-master-lighter" />
                    )}
                  </span>
                  <span className="m-l-25 block">{messages.all}</span>
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updatePriority"
                  onClick={e => this.updatePriority(e, 3)}
                >
                  <span className="top-left m-t-5">
                    {query.priority === '3' ? (
                      <i className="fa-fw fas fa-check-square text-primary" />
                    ) : (
                      <i className="fa-fw fas fa-square text-master-lighter" />
                    )}
                  </span>
                  <span className="m-l-25 block">
                    <i className="fas fa-exclamation-circle text-danger m-r-5 sm-m-r-0" />
                    {messages.leadPriority.critical}

                    <div className="text-left no-margin no-padding fs-10 lh-normal text-master">
                      <div>1. {messages.leads_manually_set_to_high_priority}</div>
                      <div>2. {messages.leads_with_no_reaction_for_2_hours_since_creation}</div>
                      <div>3. {messages.leads_that_were_not_updated_for_2_days}</div>
                    </div>
                  </span>
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updatePriority"
                  onClick={e => this.updatePriority(e, 2)}
                >
                  <span className="top-left m-t-5">
                    {query.priority === '2' ? (
                      <i className="fa-fw fas fa-check-square text-primary" />
                    ) : (
                      <i className="fa-fw fas fa-square text-master-lighter" />
                    )}
                  </span>
                  <span className="m-l-25 block">
                    <i className="far fa-arrow-up text-warning m-r-5 sm-m-r-0" /> {messages.leadPriority.high}
                  </span>
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updatePriority"
                  onClick={e => this.updatePriority(e, 1)}
                >
                  <span className="top-left m-t-5">
                    {query.priority === '1' ? (
                      <i className="fa-fw fas fa-check-square text-primary" />
                    ) : (
                      <i className="fa-fw fas fa-square text-master-lighter" />
                    )}
                  </span>
                  <span className="m-l-25 block">
                    <i className="far fa-minus  m-r-5 sm-m-r-0" />
                    {messages.leadPriority.normal}
                  </span>
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updatePriority"
                  onClick={e => this.updatePriority(e, 0)}
                >
                  <span className="top-left m-t-5">
                    {query.priority === '0' ? (
                      <i className="fa-fw fas fa-check-square text-primary" />
                    ) : (
                      <i className="fa-fw fas fa-square text-master-lighter" />
                    )}
                  </span>
                  <span className="m-l-25 block">
                    <i className="far fa-arrow-down text-success m-r-5 sm-m-r-0" />
                    {messages.leadPriority.low}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        }
      />
    );
  }
}
ListFilterLeadPriority.defaultProps = {};

export default withRouter(injectIntl(ListFilterLeadPriority));
